import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {DcpAddToCartModule} from '@app/checkout/add-to-cart/dcp-add-to-cart.module';

import {ConfiguratorComponentsModule} from '@app/product/configurator/configurator-components/configurator-components.module';
import {DerivativePricesComponent} from '@app/product/configurator/configurator-components/price-display/derivative-prices/derivative-prices.component';
import {PriceDisplayComponent} from '@app/product/configurator/configurator-components/price-display/price-display.component';

import {GroupSkipDirective} from '@dcp/accessibility';
import {DcpDateFormatter, LoadingIndicatorComponent, LoadingPageComponent} from '@dcp/configurator';
import {FormlyModule} from '@ngx-formly/core';
import {I18nModule, UrlModule} from '@spartacus/core';
import {GenericLinkModule} from '@spartacus/storefront';
import {EditCartEntryComponent} from './edit-cart-entry/edit-cart-entry.component';
import {EditCartPageComponent} from './edit-cart-page/edit-cart-page.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    DcpAddToCartModule,
    ConfiguratorComponentsModule,
    UrlModule,
    ReactiveFormsModule,
    FormlyModule,
    GenericLinkModule,
    DcpDateFormatter,
    LoadingIndicatorComponent,
    LoadingPageComponent,
    GroupSkipDirective,
    EditCartEntryComponent,
    EditCartPageComponent,
    PriceDisplayComponent,
    DerivativePricesComponent,
  ],
  exports: [EditCartEntryComponent, EditCartPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CartEditModule {}
